<template>
    <div class="position-absolute inset-0 d-flex flex-column align-items-end pe-none p-2 gap-6">
        <div>
            <button type="button" class="btn btn-secondary floating-button circle-button d-lg-none" @click="handleClose" :title="$trans('storefront::image_editor.close')"><i class="las la-times"></i></button>
        </div>

        <div class="d-flex flex-column justify-content-center gap-6 flex-grow-1">
            <div class="d-flex flex-column gap-1">
                <button type="button" class="btn btn-secondary floating-button" @mousedown="animateButton($event)" @click="zoomIn()" :title="$trans('storefront::image_editor.zoom_in')"><i class="las la-search-plus"></i></button>
                <button type="button" class="btn btn-secondary floating-button" @mousedown="animateButton($event)" @click="zoomOut()" :title="$trans('storefront::image_editor.zoom_out')"><i class="las la-search-minus"></i></button>
            </div>

            <div class="d-flex flex-column gap-1">
                <button type="button" class="btn btn-secondary floating-button" @mousedown="animateButton($event)" @click="undo()" :disabled="!store.canUndo" :title="$trans('storefront::image_editor.undo')"><i class="las la-undo-alt"></i></button>
                <button type="button" class="btn btn-secondary floating-button" @mousedown="animateButton($event)" @click="redo()" :disabled="!store.canRedo" :title="$trans('storefront::image_editor.redo')"><i class="las la-redo-alt"></i></button>
            </div>

            <div v-if="showing" class="d-flex flex-column gap-1">
                <button type="button" class="btn btn-secondary floating-button" @mousedown="animateButton($event)" @click="moveForwards()" :title="$trans('storefront::image_editor.move_object_forward')"><i class="las la-arrow-up"></i></button>
                <button type="button" class="btn btn-secondary floating-button" @mousedown="animateButton($event)" @click="moveBackwards()" :title="$trans('storefront::image_editor.move_object_backwards')"><i class="las la-arrow-down"></i></button>
                <button type="button" class="btn btn-secondary floating-button" @mousedown="animateButton($event)" @click="removeObjects()" :title="$trans('storefront::image_editor.remove_objects')"><i class="las la-trash-alt"></i></button>
            </div>

            <div class="d-flex flex-column gap-1">
                <button type="button" class="btn btn-secondary floating-button d-lg-none" @mousedown="animateButton($event)" @click="openMobileTutorial()"><i class="las la-question-circle" style="scale: 1.2"></i></button>
                <button type="button" class="btn btn-secondary floating-button d-lg-none" @mousedown="animateButton($event)" @click="openDocumentSettings()"><i class="las la-shopping-cart"></i></button>
            </div>
        </div>

        <mobile-tutorial ref="mobile-tutorial"></mobile-tutorial>
    </div>
</template>

<style lang="scss" scoped>
@use "Themes/Storefront/resources/assets/public/sass/utils/_variables.scss" as var;

.floating-button {
    border-radius: 3px;
    pointer-events: auto;

    line-height: 0px;
    padding: 9px;

    font-size: 18px;
    transition: 0.05s all ease-out;
    animation: slideIn 0.1s ease-out forwards;

    z-index: 1;

    @keyframes slideIn {
        from {
            right: -100px;
        }
        to {
            right: 0;
        }
    }

    @media (max-width: var.$breakpoint-sm) {
        background: black !important;
    }

    @media (min-width: var.$breakpoint-md) {
        &:hover {
            scale: 1.1;
        }

        &:hover:active {
            scale: .9;
            background: #414141;
        }
    }
}

.circle-button {
    border-radius: 100%;
    aspect-ratio: 1 / 1;
}
</style>

<script>
import {useImageEditorStore} from "./store";
import {changeZoom} from "./js/panAndZoom";
import {confirmClose} from "./js/actions";
import MobileTutorial from "./components/mobile-tutorial/MobileTutorial";
import {isMobileDevice} from "./imageEditor";

export default {
    components: {MobileTutorial},
    setup() {
        const store = useImageEditorStore();

        return {
            store: store,
        }
    },
    data() {
        return {
            showing: false,
        }
    },
    mounted() {
        let app = this;

        app.$nextTick(() => {
            app.store.canvas.on({
                'selection:updated': app.onSelect,
                'selection:created': app.onSelect,
                'selection:cleared': app.onDeselect,
            });
        });

        document.addEventListener('keydown', function (event) {
            if (event.key === 'Delete' || event.keyCode === 46) {
                app.removeObjects();
            }
        });
    },
    methods: {
        onSelect() {
            this.showing = true;
        },
        onDeselect() {
            this.showing = false;
        },
        moveForwards() {
            let activeObject = this.store.canvas.getActiveObject();
            if (!activeObject) return;

            activeObject.bringForward();
            this.store.canvas.requestRenderAll();
            window.imageEditor.saveState(`bringForward`);
        },
        moveBackwards() {
            let activeObject = this.store.canvas.getActiveObject();
            if (!activeObject) return;

            activeObject.sendBackwards();
            this.store.canvas.requestRenderAll();
            window.imageEditor.saveState(`sendBackwards`);
        },
        removeObjects() {
            let activeObjects = this.store.canvas.getActiveObjects();
            for (let object of activeObjects) {
                this.store.canvas.remove(object);
            }

            this.store.canvas.discardActiveObject();
        },
        zoomIn() {
            this.store.canvas.zoomIn(1.3);
        },
        zoomOut() {
            this.store.canvas.zoomIn(0.7);
        },
        handleClose() {
            confirmClose();
        },
        animateButton(event, actionType) {
            const clickedElement = event.currentTarget;

            if (isMobileDevice()) {
                clickedElement.style.transform = 'scale(1.2)';
                setTimeout(() => {
                    clickedElement.style.transform = 'scale(1)';
                }, 200);
            }
        },
        openMobileTutorial() {
            this.$refs['mobile-tutorial'].open();
        },
        openDocumentSettings() {
            window.settingCard_toggle();
        },
        undo() {
            window.imageEditor.undo();
        },
        redo() {
            window.imageEditor.redo();
        },
    },
}
</script>
